import { axios } from '@/repositories'
// import services from '../jsons-data/mocks/equip-service.json'

const resource = '/v1/stay'

export default {
  async getServiceDetail(menuNo) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/${menuNo}/equipments-services`).then(
        (response) => {
          // resolve(services)
          resolve(response.data)
        },  
        (error) => {
          // resolve(services)
          reject(error.data)
        }
      )
    })
  }
}

